import { FormattedDate, FormattedMessage, FormattedNumber, FormattedTime } from 'react-intl';

interface TimestampAndMileageProps {
    timestamp: string | undefined;
    mileage: number | undefined;
    textColor?: 'dark' | 'gray';
}

const TimestampAndMileage = ({ timestamp, mileage, textColor = 'dark' }: TimestampAndMileageProps) => {
    if (!timestamp && !mileage) {
        return <span>-</span>;
    }

    return (
        <span className={`display-flex flex-wrap text-color-${textColor} text-size-14`}>
            {timestamp && (
                <span>
                    <FormattedDate value={timestamp} day="2-digit" month="2-digit" year="numeric" />
                    {' - '}
                    <FormattedTime value={timestamp} hour="2-digit" minute="2-digit" />
                </span>
            )}
            {mileage != null && (
                <span>
                    &nbsp;|&nbsp;
                    <FormattedNumber value={Math.round(mileage)} />{' '}
                    <FormattedMessage id="intl-msg:engineOil.unit.kilometers" />
                </span>
            )}
        </span>
    );
};

export default TimestampAndMileage;
